/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_AdvertisingInputs */

const en_val_advertising = /** @type {(inputs: Val_AdvertisingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advertising`)
};

const es_val_advertising = /** @type {(inputs: Val_AdvertisingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicidad`)
};

const fr_val_advertising = /** @type {(inputs: Val_AdvertisingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicité`)
};

const de_val_advertising = /** @type {(inputs: Val_AdvertisingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werbung`)
};

const ja_val_advertising = /** @type {(inputs: Val_AdvertisingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`広告`)
};

const zh_val_advertising = /** @type {(inputs: Val_AdvertisingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`广告/商业`)
};

const ar_val_advertising = /** @type {(inputs: Val_AdvertisingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعلاني`)
};

const id_val_advertising = /** @type {(inputs: Val_AdvertisingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periklanan`)
};

const it_val_advertising = /** @type {(inputs: Val_AdvertisingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicità`)
};

const ru_val_advertising = /** @type {(inputs: Val_AdvertisingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекламная`)
};

const pt_val_advertising = /** @type {(inputs: Val_AdvertisingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicidade`)
};

const ko_val_advertising = /** @type {(inputs: Val_AdvertisingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`광고`)
};

/**
* | output |
* | --- |
* | "Advertising" |
*
* @param {Val_AdvertisingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_advertising = /** @type {((inputs?: Val_AdvertisingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_AdvertisingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_advertising(inputs)
	if (locale === "es") return es_val_advertising(inputs)
	if (locale === "fr") return fr_val_advertising(inputs)
	if (locale === "de") return de_val_advertising(inputs)
	if (locale === "ja") return ja_val_advertising(inputs)
	if (locale === "zh") return zh_val_advertising(inputs)
	if (locale === "ar") return ar_val_advertising(inputs)
	if (locale === "id") return id_val_advertising(inputs)
	if (locale === "it") return it_val_advertising(inputs)
	if (locale === "ru") return ru_val_advertising(inputs)
	if (locale === "pt") return pt_val_advertising(inputs)
	return ko_val_advertising(inputs)
});